import React, { Fragment } from "react";
import styles from "./SearchForm.module.css";

class SearchForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      input: "",
    }
  }

  handleInputChange = event => {
    const input = event.target.value;
    const { onInputChange } = this.props;

    this.setState({
      input: input,
    });
    onInputChange(input);
  }

  render() {
    const { input } = this.state;
    const { id, icon } = this.props;

    return (
      <Fragment>
        <i className={icon}></i>
        <input
          id={id}
          type="text"
          value={input}
          placeholder="Vorname Nachname"
          onChange={this.handleInputChange}
          className={styles.input}
        />
      </Fragment>
    )
  }
}

export default SearchForm;



// WEBPACK FOOTER //
// ./src/components/SearchForm/SearchForm.js